import MagazineCreate from '_modules/magazine/views/MagazineCreate.vue';
import MagazineList from '_modules/magazine/views/MagazineList.vue';
import MagazineEdit from '_modules/magazine/views/MagazineEdit.vue';
import Magazines from './Root.vue';

export default {
  path: 'revistas',
  name: 'magazines',
  component: Magazines,
  redirect: '/revistas/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-magazine-list',
      component: MagazineList,
    },
    {
      path: 'novo',
      name: 'admin-magazine-new',
      component: MagazineCreate,
    },
    {
      path: ':magazineId',
      name: 'admin-magazine-edit',
      component: MagazineEdit,
    },
  ],
};
